import { TEXT_ALIGNMENT, WIDGET_DEFAULT_FONT } from 'constants/fonts';
import { WidgetType } from 'types/widget.types';

import {
  DEFAULT_FORM_FIELD_VALUE,
  DEFAULT_LONG_TEXT_FIELD_HEIGHT,
  DEFAULT_LONG_TEXT_FIELD_WIDTH,
  DEFAULT_SELECTION_FIELD_DATA,
  DEFAULT_SELECTION_FIELD_HEIGHT,
  DEFAULT_SELECTION_FIELD_WIDTH,
  DEFAULT_SHORT_TEXT_FIELD_HEIGHT,
  DEFAULT_SHORT_TEXT_FIELD_WIDTH,
  DEFAULT_TEXTAREA_HEIGHT,
  MIN_HORIZONTAL_HEIGHT,
  MIN_VERTICAL_HEIGHT,
  MIN_WIDTH,
} from './FormWidget.config';
import {
  FontStyleOption,
  FontWeightOption,
  FormType,
  InputType,
  LabelAlignment,
  LabelPosition,
  SelectionFieldData,
  TextDecorationOption,
} from './FormWidget.types';
import { VERSION } from './FormWidget.upgrade';

export const generateDefaultData = (type: FormType = FormType.ShortQuestion) => {
  let defaultData = {
    widthPx: DEFAULT_SHORT_TEXT_FIELD_WIDTH,
    heightPx: DEFAULT_SHORT_TEXT_FIELD_HEIGHT,
    field: DEFAULT_FORM_FIELD_VALUE[InputType.Text],
    selectionFieldData: {} as SelectionFieldData,
    altText: FormType.ShortQuestion,
  };

  if (type === FormType.LongQuestion) {
    defaultData = {
      ...defaultData,
      widthPx: DEFAULT_LONG_TEXT_FIELD_WIDTH,
      heightPx: DEFAULT_LONG_TEXT_FIELD_HEIGHT,
      field: DEFAULT_FORM_FIELD_VALUE[InputType.Textarea],
      altText: FormType.LongQuestion,
    };
  } else if (type === FormType.SelectionField) {
    defaultData = {
      ...defaultData,
      widthPx: DEFAULT_SELECTION_FIELD_WIDTH,
      heightPx: DEFAULT_SELECTION_FIELD_HEIGHT,
      field: DEFAULT_FORM_FIELD_VALUE[type],
      selectionFieldData: DEFAULT_SELECTION_FIELD_DATA,
      altText: FormType.SelectionField,
    };
  }

  const { widthPx, heightPx, field, selectionFieldData, altText } = defaultData;
  return {
    widgetType: WidgetType.Form,
    widgetData: {
      version: VERSION,
      widthPx,
      heightPx,
      topPx: 0,
      leftPx: 0,
      rotateDeg: 0,
      // Default form widget data
      type,
      style: {
        lineHeight: '1',
        fontWeight: FontWeightOption.Normal,
        fontStyle: FontStyleOption.Normal,
        textDecoration: TextDecorationOption.None,
        fontSize: 16,
        fontFamily: WIDGET_DEFAULT_FONT,
        textAlign: TEXT_ALIGNMENT.left,
        alignSelf: LabelAlignment.center,
        color: '#000',
        // Label min width to prevent label height overflow when resizing
        minWidth: MIN_WIDTH,

        backgroundColor: '#fff',
        borderRadius: 6,
        borderColor: '#8c8c8c',
        borderWidth: 1,

        gap: 12,
      },
      altText,
      isDecorative: false,
      submitButtonLabel: 'Submit',
      field,
      labelPosition: LabelPosition.Top,
      textAreaHeightPx: DEFAULT_TEXTAREA_HEIGHT,
      selectionFieldData,
    },
  };
};

export const getMinSize = (labelHeight: number = 0, fontSize: number, labelPosition: LabelPosition) => {
  const isHorizontal = labelPosition === LabelPosition.Left;
  let minSize = { minWidth: MIN_WIDTH, minHeight: isHorizontal ? MIN_HORIZONTAL_HEIGHT : MIN_VERTICAL_HEIGHT };
  // Consider multiline
  if (!isHorizontal && labelHeight > fontSize) {
    minSize.minHeight += labelHeight;
  }
  return minSize;
};
